import React from 'react'

export const Admin = () => {
    return (
        <div>
            <h1>Hola estamos en Admin</h1>
        </div>
    )
}
